var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "va-row" }, [
    _c(
      "div",
      { staticClass: "flex xs2 md2" },
      [
        _c("vuestic-simple-select", {
          ref: "selInput",
          attrs: {
            "option-key": "keyName",
            readonly: true,
            options: _vm.selOptions,
          },
          model: {
            value: _vm.singleSelOption,
            callback: function ($$v) {
              _vm.singleSelOption = $$v
            },
            expression: "singleSelOption",
          },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "flex xs2 md2" }, [
      _c(
        "button",
        { staticClass: "btn btn-primary btn-sm", on: { click: _vm.getData } },
        [_vm._v("\n      " + _vm._s(_vm.$t("buttons.search")) + "\n    ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }